import { Types } from "../../../../redux/types/types";
import {
  loadOffices,
  addOffice,
  editOffice,
  deleteOfficeQuery,
} from "../../firebase/organizationChartService";
import {
  uiOpenSuccessAlert,
  setSuccessMsg,
  uiCloseModalEdit,
  uiCloseModalAdd,
  uiCloseModalDelete,
  uiOpenAlertExists,
  setErrorMsg,
  uiOpenErrorAlert,
} from "../../../../redux/actions/uiActions";
import { Office } from "../../doc/OrganizationChart";
import { IValidateOffice } from "../../form/IValidateOffice";
import { validateOfficeUser } from "../../firebase/UsersService";
import { deleteOfficeAudit } from "../../../audit/firebase/AuditServices";
import { IAuditDoc } from "../../../audit/doc/IAuditDoc";
import { AppState } from "../../../../redux/reducers/rootReducer";

// Crear nueva oficina
export const startNewOrganizationChart = (
  values: Office,
  nameProducionOffice: string,
  idProductionOffice: string
) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;
    const { offices } = getState().organizationChart;
    const officesByProductionOffice = offices.filter(
      (el: Office) => el.idProductionOffice === values.idProductionOffice
    );
    const existsOfficeName = officesByProductionOffice.filter(
      (el: Office) => el.name === values.name
    );

    if (existsOfficeName.length > 0) {
      dispatch(uiOpenAlertExists());
    } else {
      const nameSplit = values.name.split(" ").join("");
      values.idOffice = `${values.idProductionOffice}_${nameSplit}`;

      const newOffice: Office = {
        name: values.name,
        idVersion: values.idVersion,
        idProductionOffice: values.idProductionOffice,
        productionOffice: nameProducionOffice,
        idOffice: values.idOffice,
      };

      await addOffice(newOffice, idEntity, idProductionOffice);
      dispatch(addNewOffice(newOffice));
      dispatch(setSuccessMsg("OfficeAddSuccess"));
      dispatch(uiCloseModalAdd());
      dispatch(officeCleanActive());
      dispatch(uiOpenSuccessAlert());
    }
  };
};

// Adiconar oficina
const addNewOffice = (office: any) => ({
  type: Types.OrganizationChartAddNew,
  payload: office,
});

export const startLoadingOffices = (idEntity: string) => {
  return async (dispatch: Function) => {
    const offices = await loadOffices(idEntity);
    if (offices) {
      dispatch(setOffices(offices));
    }
  };
};
// setear las oficinas
export const setOffices = (offices: Office) => ({
  type: Types.OrganizationChartLoad,
  payload: offices,
});

// Oficina Activa
export const activeOffice = (office: Office) => ({
  type: Types.OrganizationCharActive,
  payload: office,
});

export const officeCleanActive = () => ({
  type: Types.OrganizationCharCleaning,
});

// Editar Oficina
export const startEditOffice = (office: Office) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;
    const { offices } = getState().organizationChart;
    const officesByProductionOffice = offices.filter(
      (el: Office) => el.idProductionOffice === office.idProductionOffice
    );
    const existsOfficeName = officesByProductionOffice.filter(
      (el: Office) => el.name === office.name
    );

    if (existsOfficeName.length > 0) {
      dispatch(uiOpenAlertExists());
    } else {
      try {
        dispatch(activeOffice(office));
        const data: IValidateOffice = {
          office: office,
          idEntity: idEntity,
        };
        await editOffice(data);
        dispatch(updateOffice(office));
        dispatch(setSuccessMsg("OfficeLabel.OfficeEditSuccess"));
        dispatch(uiCloseModalEdit());
        dispatch(officeCleanActive());
        dispatch(uiOpenSuccessAlert());
      } catch (error: any) {
        throw new Error(error);
      }
    }
  };
};

export const updateOffice = (office: Office) => ({
  type: Types.OrganizationChartUpdated,
  payload: office,
});

// borrar oficina

export const startDeleting = (office: Office) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;
    const { user } = (getState() as AppState).auth;
    try {
      const data: IValidateOffice = {
        office: office,
        idEntity: idEntity,
      };
      let ussersOffice = await validateOfficeUser(data);
      if (ussersOffice.length > 0) {
        dispatch(setSuccessMsg("OfficeLabel.errorDelete"));
        dispatch(uiCloseModalDelete());
        dispatch(uiOpenErrorAlert());
        return;
      }
      const audit: IAuditDoc = {
        id: "",
        createdAt: new Date().toISOString(), // Add a timestamp
        action: "delete",
        user: user?.id,
        idEntity: idEntity,
      };

      await deleteOfficeAudit(office, audit);
      await deleteOfficeQuery(data);
      
      dispatch(deleteOffice(office.idOffice));
      dispatch(setSuccessMsg("OfficeLabel.SuccesDeleteOffice"));
      dispatch(uiCloseModalDelete());
      dispatch(officeCleanActive());
      dispatch(uiOpenSuccessAlert());
    } catch (error: any) {
      throw new Error(error);
    }
  };
};

export const deleteOffice = (idOffice: string | undefined) => ({
  type: Types.OrganizationCharDelete,
  payload: idOffice,
});
